import React from 'react';
import VisitorsTab from './components/visitors-tab';
import './style.scss';

const VisitorList = () => {
	return <VisitorsTab />;
};

export default VisitorList;
